import { render, staticRenderFns } from "./urlsView.vue?vue&type=template&id=73330a7b&"
import script from "./urlsView.vue?vue&type=script&lang=js&"
export * from "./urlsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports